import NewsletterSection from '@/components/NewsletterSection'
import { getInspirations, getInspirationCategories } from '@/lib/api'

export default async function InspirationsPage() {
  const [data, categories] = await Promise.all([
    getInspirations({ page: 1, paginate: 6 }),
    getInspirationCategories(),
  ])

  const posts = data?.inspirations || []
  const pagination = data?.pagination
  const cats = categories || []

  const fallbackPosts = [
    { id: 1, title: 'A Doctor Of The People: Hani Alfifai', image: '/blog-homs.jpg', created_at: '24.08.2024', likes_count: 23, comments_count: 10, description: "Ghassan Alfifai's Respected Uncle, Was More Than Ju...", slug: '1' },
    { id: 2, title: 'Homs Was More Than Just A Place; It Was A Home', image: '/story-event.jpg', created_at: '24.08.2024', likes_count: 23, comments_count: 10, description: "Ghassan Al Rifai's Hometown, Homs, Syria, Was A Vibrant City Fill...", slug: '2' },
    { id: 3, title: 'Inspired By Steve Jobs: A Syrian Connection', image: '/blog-steve-jobs.jpg', created_at: '24.08.2024', likes_count: 23, comments_count: 10, description: 'Explore The Latest Trends In Air Travel, Tips For A Smooth Journey...', slug: '3' },
    { id: 4, title: 'Yousef Ghassan Al Rifai: The Promising Mind', image: '/ghassan-profile.jpg', created_at: '24.08.2024', likes_count: 23, comments_count: 10, description: '', slug: '4' },
    { id: 5, title: "A Rising Star: Ghassan's Daughter Embraces Entrepreneurship", image: '/investment-wealth.jpg', created_at: '24.08.2024', likes_count: 23, comments_count: 10, description: '', slug: '5' },
    { id: 6, title: 'Loujina Hafez : A Pillar Of Support And Inspiration', image: '/ghassan-artistic.jpg', created_at: '24.08.2024', likes_count: 23, comments_count: 10, description: '', slug: '6' },
  ]
  const displayPosts = posts.length > 0 ? posts : fallbackPosts

  return (
    <>
      {/* HERO */}
      <section className="relative overflow-hidden" style={{ height: '300px', background: '#07090e' }}>
        <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '44%', zIndex: 1 }}>
          <img src="/ghassan-artistic.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.5 }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(90deg, rgba(7,9,14,0.6) 0%, transparent 70%)' }} />
        </div>
        <div style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: '44%', zIndex: 1 }}>
          <img src="/ghassan-real.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.45 }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(270deg, rgba(7,9,14,0.6) 0%, transparent 70%)' }} />
        </div>
        <div style={{ position: 'absolute', left: '10px', bottom: '-10px', fontSize: '210px', fontWeight: 900, color: 'transparent', WebkitTextStroke: '1.5px rgba(255,255,255,0.07)', lineHeight: 1, zIndex: 2, userSelect: 'none' }}>Ch</div>
        <div style={{ position: 'absolute', right: '16px', top: '10px', fontSize: '150px', fontWeight: 900, color: 'transparent', WebkitTextStroke: '1.5px rgba(255,255,255,0.06)', lineHeight: 1, zIndex: 2, userSelect: 'none' }}>R</div>
        <div style={{ position: 'absolute', inset: 0, zIndex: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <h1 style={{ fontSize: '40px', fontWeight: 900, color: '#fff', letterSpacing: '0.14em' }}>INSPIRATION</h1>
        </div>
        <div style={{ position: 'absolute', bottom: '20px', right: '20px', zIndex: 10, width: '48px', height: '48px', borderRadius: '50%', background: '#f97316', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
        </div>
      </section>

      {/* FILTER + GRID */}
      <section style={{ background: '#07090e', padding: '48px 0 60px' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 32px' }}>
          {/* Category filter */}
          <div style={{ maxWidth: '420px', margin: '0 auto 40px' }}>
            <label style={{ fontSize: '12px', color: 'rgba(255,255,255,0.65)', marginBottom: '6px', display: 'block' }}>Filter by Category:</label>
            <div style={{ position: 'relative' }}>
              <select style={{ width: '100%', padding: '10px 36px 10px 14px', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.10)', borderRadius: '4px', color: 'rgba(255,255,255,0.60)', fontSize: '12px', appearance: 'none', cursor: 'pointer', outline: 'none' }}>
                <option value="">All Categories</option>
                {cats.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
              <div style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="2"><polyline points="6,9 12,15 18,9"/></svg>
              </div>
            </div>
          </div>

          {/* 3x2 grid */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '40px' }}>
            {displayPosts.map((post: any) => (
              <div key={post.id} style={{ borderRadius: '6px', overflow: 'hidden', border: '1px solid rgba(25,50,140,0.65)', background: 'rgba(8,12,32,0.6)', cursor: 'pointer' }}>
                <div style={{ height: '160px', overflow: 'hidden' }}>
                  <img src={post.image} alt={post.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ padding: '14px' }}>
                  <h3 style={{ fontSize: '13px', fontWeight: 700, color: '#fff', marginBottom: '8px', lineHeight: 1.4 }}>{post.title}</h3>
                  {post.description && (
                    <p style={{ fontSize: '11px', color: 'rgba(255,255,255,0.48)', lineHeight: 1.7, marginBottom: '10px' }}>
                      {post.description.replace(/<[^>]*>/g, '').slice(0, 80)}...
                    </p>
                  )}
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: '10px', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: 'rgba(249,115,22,0.85)', fontSize: '10px' }}>
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                      {post.created_at}
                    </div>
                    <div style={{ display: 'flex', gap: '10px', color: 'rgba(255,255,255,0.45)', fontSize: '10px' }}>
                      <span style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
                        {post.likes_count}
                      </span>
                      <span style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                        {post.comments_count}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
            {[1, 2, 3, 4, '...', pagination?.total_pages || 10].map((p, i) => (
              <button key={i} style={{ width: p === '...' ? 'auto' : '32px', height: '32px', borderRadius: '4px', border: 'none', cursor: 'pointer', fontSize: '12px', fontWeight: 600, background: p === 1 ? '#f97316' : 'transparent', color: p === 1 ? '#fff' : 'rgba(255,255,255,0.55)', padding: p === '...' ? '0 4px' : '0' }}>{p}</button>
            ))}
          </div>
        </div>
      </section>

      <NewsletterSection />
    </>
  )
}
